<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10a5 5 0 1 0-.01-10.01A5 5 0 0 0 12 10m0-7a2 2 0 1 1 0 4 2 2 0 0 1 0-4m12 15h-4v-1.5a5.5 5.5 0 0 0-5.5-5.5h-5A5.5 5.5 0 0 0 4 16.5V18H0v3h1v3h3v-3h16v3h3v-3h1zm-7-1.5V18h-3.43l-.67-2.34L14.01 14h.49a2.5 2.5 0 0 1 2.5 2.5m-10 0A2.5 2.5 0 0 1 9.5 14h.49l1.1 1.66-.66 2.34H7z"/></svg>
</template>
